import { Modal } from '../ui/Modal';
import { formatDeliveryMoney } from '../../lib/deliveryArrangements';
import type { LalamoveLiveOrder } from '../../lib/deliveryArrangements';

type LalamoveOrderViewModalProps = {
  order: LalamoveLiveOrder | null;
  open: boolean;
  onClose: () => void;
};

export function LalamoveOrderViewModal({ order, open, onClose }: LalamoveOrderViewModalProps) {
  if (!order) return null;

  return (
    <Modal open={open} onClose={onClose} title={`Lalamove order — ${order.orderId}`} wide>
      <div className="dem-web-order-detail">
        <div className="dem-web-order-detail__grid">
          <div>
            <span className="dem-web-order-detail__label">Status</span>
            <strong>{order.status}</strong>
          </div>
          <div>
            <span className="dem-web-order-detail__label">Fee</span>
            <strong>
              {order.feeAmount != null ? formatDeliveryMoney(order.feeAmount, 'SGD') : '—'}
            </strong>
          </div>
          <div>
            <span className="dem-web-order-detail__label">Tracking</span>
            {order.trackingUrl ? (
              <a href={order.trackingUrl} target="_blank" rel="noreferrer">
                Open tracking link
              </a>
            ) : (
              <span>—</span>
            )}
          </div>
          <div>
            <span className="dem-web-order-detail__label">Driver ID</span>
            <span>{order.driverId || '—'}</span>
          </div>
        </div>

        <h3 className="dem-web-order-detail__items-title">Stops</h3>
        <div className="dem-web-order-detail__table">
          <div className="dem-web-order-detail__table-head" aria-hidden>
            <span>#</span>
            <span>Contact</span>
            <span>Phone</span>
            <span>Address</span>
          </div>
          {order.stops.map((stop, index) => (
            <div key={stop.stopId || `${index}-${stop.address}`} className="dem-web-order-detail__table-row">
              <span>{index === 0 ? 'Pickup' : `Dropoff ${index}`}</span>
              <span>{stop.name || '—'}</span>
              <span>{stop.phone || '—'}</span>
              <span>{stop.address || '—'}</span>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
}
